import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import DocumentVersion from '../../../interfaces/document-version';
import DocumentVersionNote from '../../../interfaces/document-version-note';
import { formatDate } from '@angular/common';
import { DocumentNotesService } from './document-notes.service';
import { CurrentUserService } from '../../../services/current-user.service';
import { User } from '../../../interfaces/user';
import { Subscription } from 'rxjs';

@Component({
    selector: 'document-notes',
    templateUrl: './document-notes.component.html',
    providers: [DocumentNotesService],
    styleUrls: ['./document-notes.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DocumentNotesComponent {
  @Input() statusVersion: DocumentVersion;

  notes: DocumentVersionNote[] = [];
  user: User;
  noteSub: Subscription;
  constructor(
    public notesService: DocumentNotesService,
    private userService: CurrentUserService
  ) {}

  ngOnInit() {
    let sub: Subscription;
    sub = this.userService.user$.subscribe((user) => {
      this.user = user;
      sub?.unsubscribe();
    });
    this.notesService.setNotes([...this.statusVersion.documentVersionNotes]);
    this.noteSub = this.notesService.notes$.subscribe((notes) => {
      let notesSlice = notes.slice();
      notesSlice.map((note) => ({ ...note }));
      this.notes = notesSlice;
    });
  }
  addNote() {
    this.notesService.createNote(this.statusVersion.id, this.user?.id ?? '');
  }
  noteTextUpdate(event: Event, note: DocumentVersionNote) {
    let text = (event.target as HTMLTextAreaElement).value;
    this.notesService.noteTextChange(note, text);
  }
  saveNote(note: DocumentVersionNote, note_text: string) {
    this.notesService.updateNote(note.id, note_text);
  }
  deleteNote(note: DocumentVersionNote) {
    this.notesService.deleteNote(note.id);
  }
}
